import { Blockchain } from "./blockchain.js";
import { Position } from "./position.js";
import { Market } from "./market.js";
export class LendingProtocol {
    blockchain;
    coinMetadataMap;
    constructor(network, client) {
        this.blockchain = new Blockchain(network, client);
        this.coinMetadataMap = new Map(); // Initialize with empty map
    }
    /**
     * Updates the coin metadata map with fresh data
     * Called by AlphalendClient after fetching coin metadata from GraphQL
     */
    updateCoinMetadataMap(coinMetadataMap) {
        this.coinMetadataMap = coinMetadataMap;
    }
    // Protocol-level methods
    async getProtocolStats(markets) {
        try {
            const marketData = await Promise.all(markets.map((market) => {
                return market.getMarketData();
            }));
            let totalSuppliedUsd = 0;
            let totalBorrowedUsd = 0;
            for (const market of marketData) {
                totalSuppliedUsd += Number(market.totalSupply) * Number(market.price);
                totalBorrowedUsd += Number(market.totalBorrow) * Number(market.price);
            }
            return {
                totalSuppliedUsd: totalSuppliedUsd.toString(),
                totalBorrowedUsd: totalBorrowedUsd.toString(),
            };
        }
        catch (error) {
            console.error("Error calculating protocol stats:", error);
            return {
                totalSuppliedUsd: "0",
                totalBorrowedUsd: "0",
            };
        }
    }
    // Market methods
    async getAllMarkets() {
        const markets = await this.blockchain.getAllMarkets();
        return markets.map((market) => new Market(market, this.coinMetadataMap));
    }
    async getMarket(marketId) {
        const market = await this.blockchain.getMarket(marketId);
        return new Market(market, this.coinMetadataMap);
    }
    async getAllMarketsData() {
        const markets = await this.getAllMarkets();
        return await Promise.all(markets.map((market) => market.getMarketData()));
    }
    async getMarketData(marketId) {
        const market = await this.getMarket(marketId);
        return await market.getMarketData();
    }
    // Position methods
    async getPositionFromPositionCapId(positionCapId) {
        const position = await this.blockchain.getPositionFromPositionCapId(positionCapId);
        return new Position(position, this.coinMetadataMap);
    }
    async getPosition(positionId) {
        const position = await this.blockchain.getPosition(positionId);
        return new Position(position, this.coinMetadataMap);
    }
    async getPositions(userAddress) {
        const positions = await this.blockchain.getPositionsForUser(userAddress);
        return positions.map((position) => new Position(position, this.coinMetadataMap));
    }
    async getUserPortfolio(userAddress) {
        const [positions, markets] = await Promise.all([
            this.getPositions(userAddress),
            this.getAllMarkets(),
        ]);
        const res = await Promise.all(positions.map((position) => position.getUserPortfolio(markets)));
        return res;
    }
    async getUserPortfolioWithMarkets(userAddress, markets) {
        const positions = await this.getPositions(userAddress);
        const res = await Promise.all(positions.map((position) => position.getUserPortfolio(markets)));
        return res;
    }
}
//# sourceMappingURL=lendingProtocol.js.map